var map = {
	"./base-avatar.vue": "073b",
	"./base-button-group.vue": "1ba8",
	"./base-button.vue": "9945",
	"./base-dialog.vue": "4b27",
	"./base-form.vue": "42f8",
	"./base-pagination.vue": "e840",
	"./base-switch-case.vue": "bf22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e51e";